import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, EmptyState } from "@/components/common";
import { Construction, Lock } from "lucide-react";
import { LEADERSHIP_NAV, STORE_NAV, FRONTLINE_NAV } from "@/components/shell/nav";

const ALL = [...LEADERSHIP_NAV, ...STORE_NAV, ...FRONTLINE_NAV];

export default function Placeholder() {
  const location = useLocation();
  const { modules } = useAuth();
  const item = ALL.find((i) => i.to === location.pathname);
  const label = item?.label || "Module";
  const moduleInactive = item?.module && modules[item.module] === false;

  if (moduleInactive) {
    return (
      <div>
        <PageHeader title={label} testId="placeholder-header" />
        <EmptyState
          icon={<Lock size={28} />}
          title="Module is inactive for this tenant"
          description="An administrator has deactivated this module. Historical records are preserved and access is restored on reactivation."
        />
      </div>
    );
  }

  return (
    <div>
      <PageHeader title={label} subtitle="Planned for a later build stage" testId="placeholder-header" />
      <EmptyState
        icon={<Construction size={28} />}
        title="Not built yet"
        description="This module is part of the WarRoom StoreCentral platform and will be delivered in an upcoming stage. The foundation, permissions, and navigation for it are already in place."
      />
    </div>
  );
}
